import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchReservas = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/salas/reservas`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchSalasPermitidas = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/salas/permitidas`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const crearReserva = async (reservaData) => {
    try {
        const response = await axios.post(`${API_URL}/api/salas/reservar`, reservaData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const actualizarReserva = async (reservaData) => {
    try {
        const response = await axios.put(`${API_URL}/api/salas/actualizarReserva`, reservaData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchPersonasReservables = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/personas/reservables`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const eliminarReserva = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/salas/eliminarReserva/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
